import React, {useState} from 'react';
import {
	Button,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalCloseButton,
	ModalOverlay,
	FormControl,
	FormLabel,
	Input,
	HStack,
} from '@tempo/core';
import {useTranslation} from 'next-i18next';
import {emailRegex} from '@constants/regex';
import type {UserForm} from '@deezer/next/features/Account/type';

type EditEmailModalProps = {
	data: string;
	isDisabled?: boolean;
	isRequired?: boolean;
	onChange: (value: Partial<UserForm>, isValid?: boolean) => void;
	isOpen: boolean;
	onClose: () => void;
	onSave: () => void;
};

const EditEmailModal = ({
	data,
	isDisabled,
	isRequired,
	isOpen,
	onClose,
	onChange,
	onSave,
}: EditEmailModalProps) => {
	const {t} = useTranslation('d4c');
	const [email, setEmail] = useState(data);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setEmail(value);
		if (onChange) {
			onChange({email: value});
		}
	};

	return (
		<Modal isOpen={isOpen} onClose={onClose} size={'2xl'}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{t('usermanager_title_changeemail_d4c-web')}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<FormControl isRequired={isRequired}>
						<FormLabel>{t('usermanager_text_email_d4c-web')}</FormLabel>
						<HStack>
							<Input
								placeholder={t('usermanager_text_emailexample_d4c-web')}
								type="email"
								value={email}
								onChange={handleChange}
								disabled={isDisabled}
							/>
						</HStack>
					</FormControl>
				</ModalBody>
				<ModalFooter>
					<Button onClick={onClose} variant="ghost">
						{t('generic_action_cancel_d4c-web')}
					</Button>
					<Button
						isDisabled={!email || !emailRegex.test(email)}
						onClick={onSave}
					>
						{t('generic_action_save_d4c-web')}
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default EditEmailModal;
